// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateLaborRateHistoryCriteria = historyToDisplay => ({
    historyToDisplay,
    type: actions.UPDATE_LABOR_RATE_HISTORY_CRITERIA
});

export const resetLaborRateHistoryCriteria = () => ({
    type: actions.RESET_LABOR_RATE_HISTORY_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/labor-rate-history/action-creators/criteria.js